import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import base from '../../../src/assets/illustrations/base.png';
import image_responsive from '../../../src/assets/illustrations/image_responsive.png';
import CardContent from '@mui/material/CardContent';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Iconify from '../../../src/components/Iconify';
import useResponsive from 'hooks/useResponsive';
//imagenes en español
import banner1_espanol from '../../../src/assets/illustrations/es/banner1_espanol.png';
import banner1_espanol_movil from '../../../src/assets/illustrations/es/banner1_espanol_movil.png';
//redux
import { useSelector } from 'redux/store';


import { useState } from 'react';
//intl
import { useIntl } from 'react-intl';


export default function MainBanner() {
    const { environment } = useSelector((state) => state.nuDetectState);
    const intl = useIntl();
    const [topHeight, setTopHeight] = useState(window.innerWidth);
    const isDesktop = useResponsive('up', 'sm');

    window.onresize = function (event) {
        setTopHeight(window.innerWidth - 1000);
    }
   /*  console.log(topHeight) */

    const banner1 = (environment.language == "es") ? banner1_espanol : base;
    const banner1_movil = (environment.language == "es") ? banner1_espanol_movil : image_responsive;

    return (
        <>
            <Card sx={{ position: 'relative', mt: { sm: '24px', xs: 0} }} >
                {isDesktop && (
                    <CardMedia image={banner1} sx={{ position: 'relative', paddingTop: '33%' }} />
                )}
                {!isDesktop && (
                    <CardMedia image={banner1_movil} sx={{ position: 'relative', paddingTop: '33%' }} />
                )}
                <CardContent sx={{
                    position: 'absolute', top: '64%', bottom: '27%', left: { sm: '7.5%', lg: '8%' }, fontSize: '5rem', color: 'white',
                    display: { sm: 'block', xs: 'none' }
                }}>
                    <Typography variant="h6" sx={{ fontWeight: 400 }}>
                        <IconButton
                            size="large"
                            color="inherit"
                            sx={{ mr: 1.2 }}
                        >
                            <Iconify icon='akar-icons:arrow-right' />
                        </IconButton>
                        {intl.formatMessage({id: 'home.texto-6', defaultMessage: 'See more'})}
                    </Typography>
                </CardContent>
            </Card>
        </>
    )
}